import gql from 'graphql-tag';

const GET_ALL_PRODUCTS = gql`
  query data {
    getProducts {
      id,
      brand,
      inRutaCode,
      category,
      inRutaShortDescriptionSpanish,
      image,
      catalog,
      vendorPrice
    }
  }
`;

export default GET_ALL_PRODUCTS;
